// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-button-control {
  line-height: inherit!important;
  font-weight: var(--ngw-text-font-weight-normal)!important;
}

.mapadapter-btn-ctrl button {
    font-size: 1.14em;
    font-weight: var(--ngw-text-font-weight-bold);
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/ol/control/createButtonControl.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA;IACI,iBAAiB;IACjB,6CAA6C;AACjD","sourcesContent":[".custom-button-control {\n  line-height: inherit!important;\n  font-weight: var(--ngw-text-font-weight-normal)!important;\n}\n\n.mapadapter-btn-ctrl button {\n    font-size: 1.14em;\n    font-weight: var(--ngw-text-font-weight-bold);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
